// AI 기능 준비 중 페이지 (공통)
import { Construction, ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/common/ui/PageHeader";

export default function ComingSoon({ title = "AI 기능", description = "이 기능은 곧 제공될 예정입니다." }) {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  return (
    <div className="p-6">
      <PageHeader>{title}</PageHeader>

      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-full p-8 mb-6">
          <Construction className="w-24 h-24 text-purple-600" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          🚧 준비 중입니다
        </h2>

        <p className="text-gray-600 mb-8 text-center max-w-md">
          {description}
          <br />
          더 나은 AI 기능을 제공하기 위해 열심히 개발 중입니다.
        </p>

        <button
          onClick={() => navigate(`/project/${projectId}/ai/dashboard`)}
          className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all"
        >
          <ArrowLeft className="w-5 h-5" />
          AI 대시보드로 돌아가기
        </button>

        <div className="mt-12 bg-purple-50 border border-purple-200 rounded-lg p-6 max-w-2xl">
          <h3 className="font-bold text-purple-900 mb-3">개발 예정 기능</h3>
          <ul className="text-sm text-purple-700 space-y-2">
            <li>✨ 안전 이미지 분석 - 시공사진 자동 위험 탐지</li>
            <li>✨ 품질 결함 탐지 - 균열/변형 자동 인식</li>
            <li>✨ 공정 지연 예측 - AI 기반 리스크 분석</li>
            <li>✨ 자재 수요 예측 - 향후 소요량 AI 예측</li>
            <li>✨ 보고서 자동 생성 - 주간/월간 보고서 AI 작성</li>
            <li>✨ 위험성 평가 AI - 작업별 위험성 자동 평가</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
